import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
    useMediaQuery,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import { useContext } from "react"
import useAlert from "../../contexts/AlertContext"
import useEndereco from "../../contexts/EnderecoContext"
import SiteContext from "../../contexts/SiteContext"
import { useTextos } from "../../contexts/TextosContext"
import { ComumCep, RegistrarLogErro } from "../../services/functions"

const useStyles = makeStyles(theme => ({
    dialogContent: {
        textAlign: "center",
    },
    contentContainer: {
        width: "80%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        justifyContent: "center",
        margin: "2rem auto 0 auto",
        [theme.breakpoints.down("sm")]: {
            width: "85%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    mapContainer: {
        width: "100%",
        aspectRatio: "16/7",
        overflow: "hidden",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    googleMapsContainer: {
        width: "100%",
        aspectRatio: "12/5",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-around",
        width: "100%",
        paddingBottom: "1rem",
        gap: "clamp(0.5rem, 5%, 1rem)",
        "& > button": {
            minWidth: "fit-content",
            width: "33%",
            margin: "0!important",
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            "& > button": {
                minWidth: "fit-content",
                width: "80%",
            },
        },
    },
    confirmarButton: {
        backgroundColor: `#28a745`,
        color: "white",
        "&:hover": {
            backgroundColor: "#28a745",
            filter: "brightness(1.05)",
        },
    },
    featureOptionList: {
        marginBottom: "1rem",
        "& svg": { marginRight: "0.5rem" },
        "& > div > div": {
            overflow: "hidden",
        },
    },
    featureOption: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        fontSize: "1rem",
        "& > svg": {
            fontSize: "1.5rem",
        },
    },
}))

export default function DialogCEP({ DialogConfirmacaoinformacoes = () => {} }) {
    const {
        aplicativoDados,

        carrinho,

        setLoading,
    } = useContext(SiteContext)

    const classes = useStyles()
    const textos = useTextos()
    const alertStart = useAlert()

    const {
        setNovoEndereco,

        abrirCEP,

        permiteRetiradaNoLocal,
        selecionarRetiradaNoLocal,

        abrirCadastroEndereco,
        fecharCadastroCEP,
    } = useEndereco()

    if (abrirCEP && aplicativoDados.tipoSelecaoEndereco !== 0)
        throw new Error("CEP opened without system parameter")

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const digitandoCep = async e => {
        try {
            let valorInput = e.target.value
            valorInput = valorInput.replace(/-/g, "")
            valorInput = valorInput.replace(/ /g, "")
            valorInput = valorInput.replace(/\//g, "")

            if (valorInput.length == 8) {
                abrirCadastroEndereco()
                fecharCadastroCEP()
                setLoading(true)
                const response = await ComumCep(valorInput, aplicativoDados)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                } else {
                    if (
                        // TODO: Simplificar
                        response.id ||
                        response.logradouro ||
                        response.bairroEspecifico ||
                        response.bairros?.length >= 1
                    ) {
                        setNovoEndereco(response)
                    } else {
                        alertStart("Não foi possível identificar seu CEP", "error")
                    }
                }
                setLoading(false)
            }
        } catch (error) {
            RegistrarLogErro(error, "digitandoCep", e.target.value)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    const handleRetiradaNoLocal = () => {
        selecionarRetiradaNoLocal()

        if (carrinho.pedido?.itens?.length) {
            DialogConfirmacaoinformacoes(true)
        }
    }

    const handleNaoSeiCEP = () => {
        setNovoEndereco({})

        abrirCadastroEndereco()
        fecharCadastroCEP()
    }

    const handleClose = () => {
        fecharCadastroCEP()
    }

    return (
        <Dialog
            open={abrirCEP}
            aria-labelledby="cep-title"
            fullWidth={true}
            maxWidth="sm"
            onClose={handleClose}
        >
            {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}

            <DialogTitle id="cep-title">
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.adicionarEndereco}
            </DialogTitle>

            <DialogContent className={classes.dialogContent}>
                <Typography gutterBottom align="center" variant="h5" component="p">
                    {textos.digiteCep}
                </Typography>
                <TextField
                    type="text"
                    autoFocus
                    fullWidth
                    name="CEP"
                    id="cepDigitando"
                    label="CEP"
                    variant="outlined"
                    onChange={digitandoCep}
                    style={{ margin: "10px 0 5px 0" }}
                />
            </DialogContent>
            <DialogActions className={classes.buttonContainer}>
                {permiteRetiradaNoLocal ? (
                    <Button variant="contained" onClick={handleRetiradaNoLocal}>
                        {textos.retirarNoLocal}
                    </Button>
                ) : null}
                <Button variant="contained" onClick={handleNaoSeiCEP}>
                    Não Sei CEP
                </Button>
            </DialogActions>
        </Dialog>
    )
}
